import {Component, Input, OnInit} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Role} from "@domain/workflow/role";
import {RelanceDetail} from "@domain/relance/relance-detail";

/**
 * Item de la liste des rôles (Relance)
 */
@Component({
    host: {'data-test-id': 'role-relance-list-item'},
    templateUrl: './role-relance-list-item.component.html'
})
export class RoleRelanceListItemComponent extends ListViewItem<Role> implements OnInit {

    //Relance courante
    @Input() extraOptions: { relance: RelanceDetail };

    ngOnInit(): void {
        //Initialisation de isSelected
        const ids = (this.extraOptions?.relance?.listeRoleRelance ?? []).map(r => r.idRole);
        this.data.isSelected = ids.includes(this.data.idRole);
    }
}